// extracted by mini-css-extract-plugin
export default {"dropdownItem":"dropdownItem__Gjeww","submenu":"submenu__mSsdM","angleRight":"angleRight__OnHIU"};